//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "LINK",
  components: {},
  props: ["moduleData"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    handleWidth: function handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "33.3%";

        case 4:
          return "25%";

        case 5:
          return "20%";

        case 6:
          return "16.6%";

        default:
          return "50%";
      }
    },
    openLink: function openLink(item) {
      var url = item.navUrl;

      if (url.indexOf("http") < 0) {
        url = "http://" + url;
      }

      window.open(url);
    }
  },
  watch: {},
  filters: {}
};